import {Divider} from '@/components/ui/divider/Divider'
import {BannerAlert} from '@/components/commons/banner-alert/BannerAlert'
import {PageCardWrapper, PageContent} from '@/components/ui/page-atoms/PageAtoms'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {EditPlannedAccessesConfirmationDialog} from '@/features/planned-accesses/components/accesses-form/edit-planned-accesses-confirmation-dialog/EditPlannedAccessesConfirmationDialog'
import {PlannedAccessesFormHeading} from '@/features/planned-accesses/components/accesses-form/planned-accesses-form-heading/PlannedAccessesFormHeading'
import {PlannedAccessesFormSections} from '@/features/planned-accesses/components/accesses-form/planned-accesses-form-sections/PlannedAccessesFormSections'
import {EditPlannedAccessFormValidationSchema} from '@/features/planned-accesses/formSchemas'
import {useToggle} from '@/hooks/useToggle'
import {useDialogStore} from '@ariakit/react'
import {useRef, useState} from 'react'
import {useTranslation} from '@/translations/i18n'
import {useFormContext} from 'react-hook-form'

export const EditPlannedAccessesFormCard = () => {
    const {t} = useTranslation()
    const viewportRef = useRef<HTMLDivElement>(null)
    const {getValues} = useFormContext<EditPlannedAccessFormValidationSchema>()

    const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false)
    const confirmationDialogStore = useDialogStore({
        open: isConfirmationDialogOpen,
        setOpen: setIsConfirmationDialogOpen
    })
    const {isActive: isErrorBannerVisible, on: showErrorBanner, off: dismissErrorBanner} = useToggle()

    const errorBannerRef = useRef<HTMLDivElement>(null)

    const onFailedSubmission = () => {
        showErrorBanner()
        confirmationDialogStore.setOpen(false)
        if (viewportRef.current) {
            viewportRef.current.scrollTo({top: 0, behavior: 'smooth'})
        }
    }
    return (
        <PageCardWrapper>
            <PlannedAccessesFormHeading
                title={t('planned_accesses:edit_planned_accesses')}
                schema={EditPlannedAccessFormValidationSchema}
                showConfirmationDialog={() => confirmationDialogStore.setOpen(true)}
                onError={onFailedSubmission}
                isEdit
            />
            <Divider direction="horizontal" />
            <PageContent padding={0}>
                <ScrollArea style={{height: '100%'}} scrollbar={<Scrollbar />} viewportProps={{ref: viewportRef}}>
                    {isErrorBannerVisible && (
                        <>
                            <BannerAlert ref={errorBannerRef} onClose={dismissErrorBanner} />
                            <Divider direction="horizontal" />
                        </>
                    )}
                    <PlannedAccessesFormSections />
                </ScrollArea>
            </PageContent>
            {isConfirmationDialogOpen && (
                <EditPlannedAccessesConfirmationDialog
                    dialogStore={confirmationDialogStore}
                    onError={onFailedSubmission}
                    defaultValues={getValues()}
                />
            )}
        </PageCardWrapper>
    )
}
